import React, { useContext, useState, useEffect } from 'react';
import Alert from '@material-ui/lab/Alert';
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import {
    Card,
    CardContent,
    Grid,
    Snackbar,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Hidden,
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core';

import StudentContext from '../../context/student-context';
import RewardContext from '../../context/reward-context';
import RewardConfirmationDialog from './RewardConfirmationDialog';
import Campaign from './donation/Campaign';
import { submitRedemptionRequest, getTransactionLogsByStudentNumber } from '../../actions/reward-actions';
import { getStudentCoins } from '../../actions/share-actions';

import { Coin } from '../shared/component';
import useStyles from '../../styles/components/rewards/stylesRewardShop';
import { getIconReward } from '../../utils/helpers/icon/iconHelper';
import { makeStyles } from '@material-ui/core/styles';
import { useOverShadowStyles } from '@mui-treasury/styles/shadow/over';
import TextInfoContent from '@mui-treasury/components/content/textInfo';
import { useN04TextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/n04';
import cx from 'clsx';

const useCustomStyles = makeStyles(() => ({
    root: {
        maxWidth: 650,
        margin: 'auto',
        borderRadius: 12,
        padding: 25,
    },
    media: {
        borderRadius: 6,
    },
}));

const RewardShop = () => {
    const styles = useCustomStyles();
    const shadowStyles = useOverShadowStyles({ inactive: true });
    const textCardContentStyles = useN04TextInfoContentStyles();
    const history = useHistory();
    const { rewardContext, dispatch } = useContext(RewardContext);
    let [totalCoins, setTotalCoins] = useState(0);
    const classes = useStyles()
    const { dispatchStudent } = useContext(StudentContext);
    const [snackBarDetails, setSnackBarDetails] = useState({
        open: false,
        message: '',
        type: '',
    });

    const initTransactionLogsByStudentNumber = async () => {
        const response = await getTransactionLogsByStudentNumber();
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        const rewardRedemptionLog = response.data
        dispatch({ type: 'SET_REWARD_REDEMPTION_LOG', rewardRedemptionLog });
    }

    useEffect(() => {
        checkRedeemButtonStatus(totalCoins, rewardContext.studentCoins)
    }, [totalCoins])

    const checkRedeemButtonStatus = (totalCoins, studentCoins) => {
        if (totalCoins <= studentCoins) {
            if (totalCoins == 0)
                dispatch({ type: 'SET_REDEEM_BUTTON_STATUS', redeemButtonStatus: false });
            else
                dispatch({ type: 'SET_REDEEM_BUTTON_STATUS', redeemButtonStatus: true });
        }
        else if (totalCoins == 0 || totalCoins > studentCoins)
            dispatch({ type: 'SET_REDEEM_BUTTON_STATUS', redeemButtonStatus: false });
    }

    const resetRewardItems = async () => {
        setTotalCoins(0);
        dispatch({ type: 'SET_REDEEM_BUTTON_STATUS', redeemButtonStatus: false });
        dispatch({ type: 'SET_TOTAL_COINS', totalCoins: 0 });

        const responseCoin = await getStudentCoins();
        if (responseCoin.status === "Success") {
            dispatch({ type: 'SET_STUDENT_COINS', studentCoins: responseCoin.data });
        }
    }

    const handleSnackBarClose = () => setSnackBarDetails({ ...snackBarDetails, open: false });
    const inputSnackBarDetails = (message, type) => setSnackBarDetails({
        open: true,
        message,
        type
    });

    const redeemRewardItems = async () => {
        dispatch({ type: 'SET_LOADING', loading: true });
        let redeemItems = [];
        (rewardContext.rewardItems).forEach((rewardItem) => {
            if (rewardItem.quantity > 0) {
                let reward = {
                    description: rewardItem.description,
                    quantity: rewardItem.quantity,
                    name: rewardItem.name,
                    coins: rewardItem.coins,
                    voucherCategoryId: rewardItem.voucherCategoryId,
                }
                redeemItems.push(reward);

            }
        });

        if (redeemItems.length < 1) {
            dispatch({ type: 'SET_LOADING', loading: false });
            inputSnackBarDetails('Please at least make 1 redemption', 'error');
        }
        else {

            let response = await submitRedemptionRequest(JSON.stringify(redeemItems));
            if (response > 200) {
                return history.push("/SessionTimeOut")
            }

            if (response.status === "Success") {
                dispatch({ type: 'SET_LOADING', loading: false });

                // handle data show UI after submit
                const rewardItems = (rewardContext.rewardItems).map((rewardItem) => {
                    rewardItem.itemCount -= rewardItem.quantity;
                    rewardItem.quantity = 0;
                    rewardItem.totalCoins = rewardItem.itemCount * rewardItem.coins;
                    return rewardItem;
                });
                const fillterRewardItems = rewardItems.filter(item => item.itemCount !== 0)
                initTransactionLogsByStudentNumber()
                dispatch({ type: 'SET_REWARD_ITEMS', rewardItems: fillterRewardItems });

                // update coin for Drawer Header
                const responseCoin = await getStudentCoins();
                dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: responseCoin.data });

                inputSnackBarDetails('You have successfully redeemed the selected items. Please patiently wait for an email regarding your rewards from AdventureLearn@singaporetech.edu.sg.', 'success');
            }
            else {
                dispatch({ type: 'SET_LOADING', loading: false });
                const rewardItems = (rewardContext.rewardItems).map((obj) => {
                    obj.quantity = 0;
                    return obj;
                });
                dispatch({ type: 'SET_REWARD_ITEMS', rewardItems });
                inputSnackBarDetails(`Redemption Failed. ( ${response.message} ). Please email to Adevnturelearn@singaporetech.edu.sg if you have any enquiries.`, 'error');
            }
            resetRewardItems();
        }
    }

    const decreaseQuantity = (rewardItem, index) => {
        if (rewardItem.quantity > 0) {
            rewardItem.quantity -= 1;

            totalCoinsVoucher()

            let rewardItems = (rewardContext.rewardItems).map((obj, indexReward) => {
                if (indexReward == index)
                    obj = rewardItem;
                return obj;
            });


            dispatch({ type: 'SET_REWARD_ITEMS', rewardItems })
            checkRedeemButtonStatus(totalCoins, rewardContext.studentCoins);
        }
    }

    const increaseQuantity = (rewardItem, index) => {
        if (rewardItem.quantity * rewardItem.coins < rewardItem.totalCoins) {
            rewardItem.quantity += 1;

            totalCoinsVoucher()

            let rewardItems = (rewardContext.rewardItems).map((obj, indexReward) => {
                if (indexReward == index)
                    obj = rewardItem;
                return obj;
            });

            dispatch({ type: 'SET_REWARD_ITEMS', rewardItems })

            checkRedeemButtonStatus(totalCoins, rewardContext.studentCoins);
        }
        else {
            inputSnackBarDetails('There is no more stock for selected item. Kindly wait for the item to restock', 'error');
        }
    }

    const handleChange = (rewardItem, index) => (e) => {
        const parseNumber = parseInt(e.target.value)
        if (parseNumber <= rewardItem.itemCount) {

            rewardItem.quantity = parseNumber;
        }
        if (e.target.value === '') {

            rewardItem.quantity = 0;
        }
        totalCoinsVoucher()
    }

    const totalCoinsVoucher = () => {
        let coins = 0
        rewardContext.rewardItems.map(item => {
            coins += (item.coins * item.quantity)
        })
        setTotalCoins(coins)
        dispatch({ type: 'SET_TOTAL_COINS', totalCoins: coins })
        rewardContext.redeemRewardItems = rewardContext.rewardItems.filter((item) => item.quantity !== 0)
        dispatch({ type: 'SET_REDEEM_REWARD_ITEMS', redeemRewardItems: rewardContext.redeemRewardItems })
    }

    return (
        <div style={{ width: '100%' }}>
            {
                rewardContext &&
                <RewardContext.Provider value={{ rewardContext, dispatch, redeemRewardItems, inputSnackBarDetails }}>
                    <Card className={cx(styles.root, shadowStyles.root)}>
                        <CardContent>
                            <TextInfoContent
                                classes={textCardContentStyles}
                                overline={'Redemption'}
                                heading={'Voucher'}
                                body={
                                    'You can redeem up to 2000 coins per week.'
                                }
                            />
                        </CardContent>
                        {rewardContext.rewardItems.length > 0 ?
                            rewardContext.rewardItems.map((rewardItem, index) => (
                                <Grid
                                    key={index}
                                    classes={{ root: classes.rootGridContainer }}
                                >
                                    <Accordion
                                        classes={{
                                            root: classes.rootAccordion,
                                            expanded: classes.expandedAccordion,
                                        }}
                                    >
                                        <AccordionSummary
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            classes={{
                                                root: classes.rootAccordionSummary,
                                                content: classes.contentAccordionSummary,
                                                expanded: classes.expandedAccordionSummary,
                                            }}
                                            className={clsx(rewardItem.quantity > 0 && classes.quantityVoucher)}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                container
                                                justify="center"
                                                alignItems="center"
                                                classes={{ root: classes.rootGridVoucher }}

                                            >
                                                <Grid item xs={6} classes={{ root: classes.rootGridDescription }}>
                                                    <div className={classes.containerImage}>
                                                        <img src={rewardItem.voucherCategoryLogo} />
                                                    </div>
                                                    <div className={classes.containerDescription}>
                                                        {rewardItem.name}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} classes={{ root: classes.rootGridCategory }}>
                                                    Available Quantity : {rewardItem.totalCoins / rewardItem.coins}
                                                </Grid>
                                                <Hidden smDown>
                                                    <Grid item xs={2} container justify="flex-end">
                                                        <Coin
                                                            coin={rewardItem.coins}
                                                            size="medium"
                                                        />
                                                    </Grid>
                                                </Hidden>
                                                <Hidden mdUp>
                                                    <Grid item xs={2} container justify="flex-end">
                                                        <Coin
                                                            coin={rewardItem.coins}
                                                            size="small"
                                                        />
                                                    </Grid>
                                                </Hidden>
                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails classes={{ root: classes.accordionDetailsRedeem }}>
                                            <Grid item xs={12}>
                                                <Grid container
                                                    direction={'row'}
                                                    alignContent={'center'}
                                                    justify={'center'}>

                                                    <Grid container justify="center" alignItems="center" classes={{ root: classes.containerRedeem }}>
                                                        <div>
                                                            <div>Qty</div>
                                                        </div>
                                                        <div className={classes.containerImgae} onClick={() => decreaseQuantity(rewardItem, index)}>
                                                            <img src={`${getIconReward().img_subtract}`} />
                                                        </div>
                                                        <div className={classes.containerInput}>
                                                            <input type="tel" value={rewardItem.quantity} onChange={handleChange(rewardItem, index)} />
                                                        </div>
                                                        <div className={classes.containerImgae} onClick={() => increaseQuantity(rewardItem, index)}>
                                                            <img src={`${getIconReward().img_plus}`} />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            ))
                            :
                            <Grid container justify="center">
                                <div>There are no items to display.</div>
                            </Grid>
                        }
                        {
                            rewardContext.rewardItems.length !== 0 &&
                            <Grid container justify="center">
                                <RewardConfirmationDialog />
                            </Grid>
                        }
                    </Card>
                    <Grid container justify="center">
                        <h3>- Or -</h3>
                    </Grid>
                    <Grid container justify="center">
                        <Campaign />
                    </Grid>
                    <Dialog
                        open={rewardContext.loading}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title" className="rewardshopdialog__dialog__title">AdventureLEARN Shop</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Please wait for a while...
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>

                    <Snackbar
                        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                        key={`bottom, center`}
                        open={snackBarDetails.open}
                        autoHideDuration={12000}>
                        <Alert onClose={handleSnackBarClose} severity={snackBarDetails.type}>
                            {snackBarDetails.message}
                        </Alert>
                    </Snackbar>
                </RewardContext.Provider>
            }
        </div>
    )
}

export { RewardShop as default }